export const getFeatureFlag = (flag: string) => {
    const props = flag.split('.')

    if (window.mc && window.mc.featureFlags) {
        let result: any = window.mc.featureFlags

        for (let i = 0; i < props.length; i++) {
            if (result === undefined) {
                return undefined
            } else {
                result = result[props[i]]
            }
        }

        return result
    } else {
        return undefined
    }
}
